import { Pipe, PipeTransform } from '@angular/core';
import { QuestionType } from '@features/opportunities/components/questionnaire-form/models/questionnaire';

@Pipe({
  name: 'isSingleChoice',
  pure: true
})
export class IsSingleChoicePipe implements PipeTransform {
  transform(questionType: QuestionType): boolean {
    return questionType === 'Single Choice';
  }
}
